module.exports = __webpack_public_path__ + "img/454447_908E9A_181716_7C7C7B-256px.a15f24a1.png";